import { VerticalSpacer } from "@superhi/design";
import styled from "styled-components";

export const Wrapper = styled(VerticalSpacer).attrs({
  amount: { small: 16, medium: 16, large: 16 },
})`
  &:not(:first-child) {
    margin-top: 40px;
  }

  &:not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const Video = styled.video`
  display: block;
  width: 100%;
  height: auto;
`;
